import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { SideNav } from './nav/SideNav';

export function Layout(props) {
  return (
    <>
      <LayoutWrap>
        <h1>지역산단 Edge System</h1>
        <SideNav />
        <Container>
          <Header />
          <Main>
            <Outlet />
          </Main>
        </Container>
      </LayoutWrap>
      <Footer />
    </>
  );
}

const LayoutWrap = styled.div`
  display: flex;
  min-height: calc(100vh - 40px);
`;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 360px;
  width: 100%;
`;

const Main = styled.main`
  flex: 1;
  padding: 0 40px;
  min-width: 1240px;
  width: 100%;
`;
